// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.extended-solutions-container {
  display: flex;
  flex-direction: column;
}
.extended-solutions-container h1 {
  padding-left: 20px;
}
.extended-solutions-container .extended-solutions-content {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
}
.extended-solutions-container .blocks-container {
  flex-direction: row;
  justify-content: space-between;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 25px;
}
.extended-solutions-container .blocks-container a {
  text-decoration: none;
  color: black;
  margin-bottom: 40px;
}
.extended-solutions-container .blocks-container a:last-child {
  display: flex;
  justify-content: left;
  margin-right: auto;
}
.extended-solutions-container .blocks-container .app-block {
  min-width: 100% !important;
}
.extended-solutions-container .blocks-container .blocks {
  border-radius: 5px;
  background: #f5f5f5;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  width: 286px;
  height: 164px;
  margin: 13px;
  padding: 15px 15px 0 15px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.extended-solutions-container .blocks-container .blocks .app-info {
  display: flex;
  align-items: center;
}
.extended-solutions-container .blocks-container .blocks .image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  width: 42px !important;
  height: 42px !important;
  border-radius: 50%;
}
.extended-solutions-container .blocks-container .blocks .image-container img {
  height: 18px;
  width: 18px;
}
.extended-solutions-container .blocks-container .blocks .app-name {
  font-size: 14px;
  padding-left: 10px;
  white-space: nowrap;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.extended-solutions-container .blocks-container .blocks .app-name h4 {
  font-family: "ABBVoice-bold";
  font-size: 14px;
  padding: 0;
  margin: 0;
}
.extended-solutions-container .blocks-container .blocks .box-content {
  font-family: "ABBVoice-regular";
  align-items: center;
}
.extended-solutions-container .blocks-container .blocks .box-content p {
  margin: 0 0 10px 0;
  font-size: 12px !important;
  text-align: left;
  margin-top: 20px;
  margin-left: 24px;
}
.extended-solutions-container .blocks-container .blocks .app-link {
  display: flex;
  margin-left: auto;
  color: #3366ff;
  font-family: "ABBVoice-medium";
  font-size: 12px;
}
.extended-solutions-container .blocks-container .blocks .app-link a {
  color: #3366ff;
  text-transform: uppercase;
  text-decoration: none;
}
.extended-solutions-container .blocks-container .blocks:hover {
  background: rgba(51, 102, 255, 0.1607843137);
  border: 1px solid #2934ff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.blocks-container .blocks .app-link-extended-solutions {
  display: flex;
  margin-left: auto;
  color: #3366ff;
  font-family: "ABBVoice-medium";
  margin-top: 18%;
}

.core-cta-btns {
  display: flex;
  flex-direction: row;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/extended_solutions.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AAAE;EACE,kBAAA;AAEJ;AAAE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AAEJ;AAAE;EACE,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AAEJ;AAAI;EACE,qBAAA;EACA,YAAA;EACA,mBAAA;AAEN;AAAI;EACE,aAAA;EACA,qBAAA;EACA,kBAAA;AAEN;AAAI;EACE,0BAAA;AAEN;AAAI;EACE,kBAAA;EACA,mBAAA;EACA,+CAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AAEN;AAAM;EACE,aAAA;EACA,mBAAA;AAER;AACM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AACR;AAAQ;EACE,YAAA;EACA,WAAA;AAEV;AAEM;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AAAR;AAEQ;EACE,4BAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;AAAV;AAIM;EACE,+BAAA;EACA,mBAAA;AAFR;AAIQ;EACE,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAFV;AAMM;EACE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,8BAAA;EACA,eAAA;AAJR;AAKQ;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AAHV;AAQI;EACE,4CAAA;EACA,yBAAA;EACA,+CAAA;AANN;;AAUA;EACE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,8BAAA;EACA,eAAA;AAPF;;AASA;EACE,aAAA;EACA,mBAAA;AANF","sourcesContent":[".extended-solutions-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  h1 {\r\n    padding-left: 20px;\r\n  }\r\n  .extended-solutions-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 0 20px;\r\n  }\r\n  .blocks-container {\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    margin-bottom: 25px;\r\n\r\n    a {\r\n      text-decoration: none;\r\n      color: black;\r\n      margin-bottom: 40px;\r\n    }\r\n    a:last-child {\r\n      display: flex;\r\n      justify-content: left;\r\n      margin-right: auto;\r\n    }\r\n    .app-block {\r\n      min-width: 100% !important;\r\n    }\r\n    .blocks {\r\n      border-radius: 5px;\r\n      background: #f5f5f5;\r\n      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\r\n      width: 286px;\r\n      height: 164px;\r\n      margin: 13px;\r\n      padding: 15px 15px 0 15px;\r\n      display: flex;\r\n      flex-direction: column;\r\n      cursor: pointer;\r\n\r\n      .app-info {\r\n        display: flex;\r\n        align-items: center;\r\n      }\r\n\r\n      .image-container {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        background-color: white;\r\n        width: 42px !important;\r\n        height: 42px !important;\r\n        border-radius: 50%;\r\n        img {\r\n          height: 18px;\r\n          width: 18px;\r\n        }\r\n      }\r\n\r\n      .app-name {\r\n        font-size: 14px;\r\n        padding-left: 10px;\r\n        white-space: nowrap;\r\n        width: 200px;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n\r\n        h4 {\r\n          font-family: \"ABBVoice-bold\";\r\n          font-size: 14px;\r\n          padding: 0;\r\n          margin: 0;\r\n        }\r\n      }\r\n\r\n      .box-content {\r\n        font-family: \"ABBVoice-regular\";\r\n        align-items: center;\r\n\r\n        p {\r\n          margin: 0 0 10px 0;\r\n          font-size: 12px !important;\r\n          text-align: left;\r\n          margin-top: 20px;\r\n          margin-left: 24px;\r\n        }\r\n      }\r\n\r\n      .app-link {\r\n        display: flex;\r\n        margin-left: auto;\r\n        color: #3366ff;\r\n        font-family: \"ABBVoice-medium\";\r\n        font-size: 12px;\r\n        a {\r\n          color: #3366ff;\r\n          text-transform: uppercase;\r\n          text-decoration: none;\r\n        }\r\n      }\r\n    }\r\n\r\n    .blocks:hover {\r\n      background: #3366ff29;\r\n      border: 1px solid #2934ff;\r\n      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\r\n    }\r\n  }\r\n}\r\n.blocks-container .blocks .app-link-extended-solutions {\r\n  display: flex;\r\n  margin-left: auto;\r\n  color: #3366ff;\r\n  font-family: \"ABBVoice-medium\";\r\n  margin-top: 18%;\r\n}\r\n.core-cta-btns {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
